import * as Immutable from "immutable";
export default class UserOverview {
  constructor(id, username, fullName, email, roles, readOnly, external, sessionActive, clientAddress, lastActivity, enabled, authServiceId, authServiceUid, authServiceEnabled, accountStatus) {
    this._value = {
      id,
      username,
      fullName,
      email,
      roles,
      readOnly,
      external,
      sessionActive,
      clientAddress,
      lastActivity,
      enabled,
      authServiceId,
      authServiceUid,
      authServiceEnabled,
      accountStatus
    };
  }
  get id() {
    return this._value.id;
  }
  get username() {
    return this._value.username;
  }
  get name() {
    return this._value.username;
  }
  get fullName() {
    return this._value.fullName;
  }
  get description() {
    return this._value.fullName;
  }
  get email() {
    return this._value.email;
  }
  get roles() {
    return this._value.roles;
  }
  get readOnly() {
    return this._value.readOnly;
  }
  get external() {
    return this._value.external;
  }
  get sessionActive() {
    return this._value.sessionActive;
  }
  get clientAddress() {
    return this._value.clientAddress;
  }
  get lastActivity() {
    return this._value.lastActivity;
  }
  get enabled() {
    return this._value.enabled;
  }
  get authServiceId() {
    return this._value.authServiceId;
  }
  get authServiceUid() {
    return this._value.authServiceUid;
  }
  get authServiceEnabled() {
    return this._value.authServiceEnabled;
  }
  get accountStatus() {
    return this._value.accountStatus;
  }
  toBuilder() {
    const {
      id,
      username,
      fullName,
      email,
      roles,
      readOnly,
      external,
      sessionActive,
      clientAddress,
      lastActivity,
      enabled,
      authServiceId,
      authServiceUid,
      authServiceEnabled,
      accountStatus
    } = this._value;
    return new Builder(
      Immutable.Map({
        id,
        username,
        fullName,
        email,
        roles,
        readOnly,
        external,
        sessionActive,
        clientAddress,
        lastActivity,
        enabled,
        authServiceId,
        authServiceUid,
        authServiceEnabled,
        accountStatus
      })
    );
  }
  static create(id, username, fullName, email, roles, readOnly, external, sessionActive, clientAddress, lastActivity, enabled, authServiceId, authServiceUid, authServiceEnabled, accountStatus) {
    return new UserOverview(
      id,
      username,
      fullName,
      email,
      roles,
      readOnly,
      external,
      sessionActive,
      clientAddress,
      lastActivity,
      enabled,
      authServiceId,
      authServiceUid,
      authServiceEnabled,
      accountStatus
    );
  }
  toJSON() {
    const {
      id,
      username,
      fullName,
      email,
      roles,
      readOnly,
      external,
      sessionActive,
      clientAddress,
      lastActivity,
      enabled,
      authServiceId,
      authServiceUid,
      authServiceEnabled,
      accountStatus
    } = this._value;
    return {
      id,
      username,
      full_name: fullName,
      email,
      roles: roles.toArray(),
      read_only: readOnly,
      external_user: external,
      session_active: sessionActive,
      client_address: clientAddress,
      last_activity: lastActivity,
      enabled,
      auth_service_id: authServiceId,
      auth_service_uid: authServiceUid,
      auth_service_enabled: authServiceEnabled,
      account_status: accountStatus
    };
  }
  static fromJSON(value) {
    const {
      id,
      username,
      full_name: fullName,
      email,
      roles,
      read_only: readOnly,
      external_user: external,
      session_active: sessionActive,
      client_address: clientAddress,
      last_activity: lastActivity,
      enabled,
      auth_service_id: authServiceId,
      auth_service_uid: authServiceUid,
      auth_service_enabled: authServiceEnabled,
      account_status: accountStatus
    } = value;
    return UserOverview.create(
      id,
      username,
      fullName,
      email,
      Immutable.Set(roles),
      readOnly != null ? readOnly : false,
      external != null ? external : false,
      sessionActive != null ? sessionActive : false,
      clientAddress,
      lastActivity,
      enabled,
      authServiceId,
      authServiceUid,
      authServiceEnabled,
      accountStatus
    );
  }
  static builder() {
    return new Builder();
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  id(value) {
    return new Builder(this.value.set("id", value));
  }
  username(value) {
    return new Builder(this.value.set("username", value));
  }
  fullName(value) {
    return new Builder(this.value.set("fullName", value));
  }
  email(value) {
    return new Builder(this.value.set("email", value));
  }
  roles(value) {
    return new Builder(this.value.set("roles", value));
  }
  readOnly(value) {
    return new Builder(this.value.set("readOnly", value));
  }
  external(value) {
    return new Builder(this.value.set("external", value));
  }
  sessionActive(value) {
    return new Builder(this.value.set("sessionActive", value));
  }
  clientAddress(value) {
    return new Builder(this.value.set("clientAddress", value));
  }
  lastActivity(value) {
    return new Builder(this.value.set("lastActivity", value));
  }
  enabled(value) {
    return new Builder(this.value.set("enabled", value));
  }
  authServiceId(value) {
    return new Builder(this.value.set("authServiceId", value));
  }
  authServiceUid(value) {
    return new Builder(this.value.set("authServiceUid", value));
  }
  authServiceEnabled(value) {
    return new Builder(this.value.set("authServiceEnabled", value));
  }
  accountStatus(value) {
    return new Builder(this.value.set("accountStatus", value));
  }
  build() {
    const {
      id,
      username,
      fullName,
      email,
      roles,
      readOnly,
      external,
      sessionActive,
      clientAddress,
      lastActivity,
      enabled,
      authServiceId,
      authServiceUid,
      authServiceEnabled,
      accountStatus
    } = this.value.toObject();
    return new UserOverview(
      id,
      username,
      fullName,
      email,
      roles,
      readOnly,
      external,
      sessionActive,
      clientAddress,
      lastActivity,
      enabled,
      authServiceId,
      authServiceUid,
      authServiceEnabled,
      accountStatus
    );
  }
}
